import createVueApp from '@/common/create_app'

Styxie.Initializers.ProfileKeywordTransactions = {
  index: async(props) => {
    const { default: Component } = await import('@/vue_widgets/profile/transactions/index.vue')
    createVueApp(Component, { props: { ...props, creditType: 'keyword' } })
  }
}
